import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 投标报价 - 已参与项目 - 需求调查
 */
export default {
  path: 'demand',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '需求调查',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 需求列表
    {
      path: 'list',
      name: 'ParticipateDemand',
      component: '/supplier-views/participate/demand',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '需求列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 调查响应
    {
      path: 'orders/:orderId/trades/:tradeId?',
      name: 'SupplierDemandTrade',
      component: '/supplier-views/demands/trade',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '调查响应',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
